import { Button } from "@components/atoms/Button"
import { Chip } from "@components/atoms/Chip"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { BlogPostGridTileFragment } from "@generated-types"
import { getTranslation } from "@utils/Translations"
import dayjs from "dayjs"
import { Link } from "eddev/routing"

export const BlogPostTile = ({ item }: { item: BlogPostGridTileFragment }) => {
  return (
    <Link href={item.uri || "#"} className="flex flex-col gap-5 relative group">
      <div className="w-full aspect-[385/256] flex items-center justify-center rounded-md overflow-hidden group-hover:md:rounded-xl transition-all duration-300 relative bg-grey-1">
        {item.featuredImage?.node?.mediaItemUrl && (
          <ResponsiveImage {...item.featuredImage.node} className="w-full h-full object-cover" />
        )}
        <div className="absolute left-0 top-0 w-full h-full pointer-events-none flex items-center justify-center opacity-0 group-hover:opacity-90 transition-opacity duration-300">
          <Button dark alwaysOpen>
            {getTranslation("readMore", "Read More")}
          </Button>
        </div>
      </div>
      <div className="w-full flex gap-3 flex-col">
        <div className="w-full flex gap-2 flex-wrap">
          {item.headerData?.category?.name && <Chip>{item.headerData?.category?.name}</Chip>}
          {item.headerData?.tags && (
            <>
              {item.headerData?.tags?.map((t, tx) => (
                <Chip key={tx} square>
                  {t?.name}
                </Chip>
              ))}
            </>
          )}
        </div>
        <p className="type-header-m my-0" dangerouslySetInnerHTML={{ __html: item.title || "" }} />
        <p className="type-ui-label flex items-center gap-2">
          <span>{dayjs(item?.date).format("MMM DD YYYY")}</span>
          {item.readTime && (
            <>
              <span>・</span>
              <span>{item.readTime}</span>
            </>
          )}
        </p>
      </div>
    </Link>
  )
}
